import { setupWorker } from "msw";
import { mockedData } from "services/mockApiService/data";

export function mockApiServiceInit() {
  const worker = setupWorker(...mockedData);
  worker.start();
}
